import React from "react";
import "../styles.css";

const MusicDownloads = () => (
  <div className="page-container">
    <h1>Music</h1>
    <p>
      Purchase digital music or CDs
    </p>
    <p>Under Construction</p>
  </div>
);

export default MusicDownloads;